module.exports = __webpack_public_path__ + "images/cc5f25d7.www_11_cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/www_11_cht.png
// module id = 540
// module chunks = 0